import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ThemeToggleButton from "../helper/ThemeToggleButton";
import { RiCarLine, RiHome5Line } from "react-icons/ri";
import { LuMapPinned } from "react-icons/lu";
import { BiPowerOff } from "react-icons/bi";
import logo from "./../assets/images/logo.png";
import logo_white from "./../assets/images/logo-white.png";
import small_logo from "./../assets/images/logo.png";
import userimg from "./../assets/images/admin.png";
import { MdModeOfTravel, MdOutlineDirectionsBoat } from "react-icons/md";
import { LuHotel } from "react-icons/lu";
import { RiQuestionAnswerLine } from "react-icons/ri";
import { FaWaterLadder } from "react-icons/fa6";

const Layout = ({ children }) => {
  let user = JSON.parse(localStorage.getItem("users"));
  let role = user?.data?.roleId?.name;

  let [sidebarActive, seSidebarActive] = useState(false);
  let [mobileMenu, setMobileMenu] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const logout = () => {
    localStorage.clear();
    localStorage.setItem("logout", Date.now().toString());

    navigate("/");
  };

  useEffect(() => {
    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest(".dropdown");

      if (!clickedDropdown) return;

      const isActive = clickedDropdown.classList.contains("open");

      // Close all dropdowns
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");
      });

      if (!isActive) {
        clickedDropdown.classList.add("open");
      }
    };

    // Attach click event listeners to all dropdown triggers
    const dropdownTriggers = document.querySelectorAll(
      ".sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link",
    );

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener("click", handleDropdownClick);
    });

    const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
    allDropdowns.forEach((dropdown) => dropdown.classList.remove("open"));

    // Function to open submenu based on current route
    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
        submenuLinks.forEach((link) => {
          if (
            link.getAttribute("href") === location.pathname ||
            link.getAttribute("to") === location.pathname
          ) {
            dropdown.classList.add("open");
          }
        });
      });
    };

    // Open the submenu that contains the open route
    openActiveDropdown();

    // Cleanup event listeners on unmount
    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener("click", handleDropdownClick);
      });
    };
  }, [location.pathname]);

  let sidebarControl = () => {
    seSidebarActive(!sidebarActive);
  };

  let mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };

  return (
    <section className={mobileMenu ? "overlay active" : "overlay "}>
      {/* sidebar */}
      <aside
        className={
          sidebarActive
            ? "sidebar active "
            : mobileMenu
              ? "sidebar sidebar-open"
              : "sidebar"
        }
      >
        <button
          onClick={mobileMenuControl}
          type="button"
          className="sidebar-close-btn"
        >
          <Icon icon="radix-icons:cross-2" />
        </button>
        <div>
          <Link to="/" className="sidebar-logo">
            <img src={logo} alt="site logo" className="light-logo" />
            <img src={logo_white} alt="site logo" className="dark-logo" />
            <img src={small_logo} alt="site logo" className="logo-icon" />
          </Link>
        </div>
        <div className="sidebar-menu-area">
          <ul className="sidebar-menu" id="sidebar-menu">
            <li className="">
              <Link
                to="/admin/home"
                className={
                  location.pathname === "/admin/home" ? "active-page" : ""
                }
              >
                <RiHome5Line className="menu-icon" />

                <span>Home</span>
              </Link>
            </li>
            {role === "admin" && (
              <li className="">
                <Link
                  to="/admin/places"
                  className={
                    location.pathname === "/admin/places" ? "active-page" : ""
                  }
                >
                  <LuMapPinned className="menu-icon" />
                  <span>Places</span>
                </Link>
              </li>
            )}
            {role === "admin" && (
              <li className="dropdown">
                <Link to="#">
                  <MdModeOfTravel className="menu-icon" />
                  <span>Tour Package</span>
                </Link>
                <ul className="sidebar-submenu">
                  <li className="">
                    <Link
                      to="/admin/travel-category"
                      // className={(navData) =>
                      //   navData.isActive ? "active-page" : ""
                      // }

                      className={
                        location.pathname === "/admin/travel-category"
                          ? "active-page"
                          : ""
                      }
                    >
                      <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />
                      Tour Category
                    </Link>
                  </li>
                  <li className="">
                    <Link
                      to="/admin/tour-package"
                      className={
                        location.pathname === "/admin/tour-package"
                          ? "active-page"
                          : ""
                      }
                    >
                      <i className="ri-circle-fill circle-icon text-success-600 w-auto" />
                      Tour Packages
                    </Link>
                  </li>
                </ul>
              </li>
            )}

            {role === "executive" && (
              <li className="dropdown">
                <Link to="#">
                  <MdModeOfTravel className="menu-icon" />
                  <span>Tour Package</span>
                </Link>
                <ul className="sidebar-submenu">
                  <li className="">
                    <Link
                      to="/admin/travel-category"
                      className={
                        location.pathname === "/admin/travel-category"
                          ? "active-page"
                          : ""
                      }
                    >
                      <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />
                      Tour Category
                    </Link>
                  </li>
                  <li className="">
                    <Link
                      to="/admin/tour-package"
                      className={
                        location.pathname === "/admin/tour-package"
                          ? "active-page"
                          : ""
                      }
                    >
                      <i className="ri-circle-fill circle-icon text-success-600 w-auto" />
                      Tour Packages
                    </Link>
                  </li>
                </ul>
              </li>
            )}

            {role === "admin" && (
              <li className="dropdown">
                <Link to="#">
                  <LuHotel className="menu-icon" />
                  <span>Hotel</span>
                </Link>
                <ul className="sidebar-submenu">
                  <li className="">
                    <Link
                      to="/admin/hoteladmin"
                      className={
                        location.pathname === "/admin/hoteladmin"
                          ? "active-page"
                          : ""
                      }
                    >
                      <i className="ri-circle-fill circle-icon text-danger-600 w-auto" />
                      Hotel Owner
                    </Link>
                  </li>
                  <li className="">
                    <Link
                      to="/admin/amenity"
                      className={
                        location.pathname === "/admin/amenity"
                          ? "active-page"
                          : ""
                      }
                    >
                      <i className="ri-circle-fill circle-icon text-success-600 w-auto" />
                      Amenity
                    </Link>
                  </li>
                  <li className="">
                    <Link
                      to="/admin/bedtype"
                      className={
                        location.pathname === "/admin/bedtype"
                          ? "active-page"
                          : ""
                      }
                    >
                      <i className="ri-circle-fill circle-icon text-info-600 w-auto" />
                      Bed Type
                    </Link>
                  </li>
                  <li className="">
                    <Link
                      to="/admin/propertytype"
                      className={
                        location.pathname === "/admin/propertytype"
                          ? "active-page"
                          : ""
                      }
                    >
                      <i className="ri-circle-fill circle-icon text-warning-600 w-auto" />
                      Property Types
                    </Link>
                  </li>
                  <li className="">
                    <Link
                      to="/admin/room-types"
                      className={
                        location.pathname === "/admin/room-types"
                          ? "active-page"
                          : ""
                      }
                    >
                      <i className="ri-circle-fill circle-icon text-success-600 w-auto" />
                      Room Type
                    </Link>
                  </li>
                </ul>
              </li>
            )}

            {role === "executive" && (
              <li className="dropdown">
                <Link to="#">
                  <LuHotel className="menu-icon" />
                  <span>Hotel</span>
                </Link>
                <ul className="sidebar-submenu">
                  <li className="">
                    <Link
                      to="/admin/hoteladmin"
                      className={
                        location.pathname === "/admin/hoteladmin"
                          ? "active-page"
                          : ""
                      }
                    >
                      <i className="ri-circle-fill circle-icon text-danger-600 w-auto" />
                      Hotel Owner
                    </Link>
                  </li>
                  <li className="">
                    <Link
                      to="/admin/amenity"
                      className={
                        location.pathname === "/admin/amenity"
                          ? "active-page"
                          : ""
                      }
                    >
                      <i className="ri-circle-fill circle-icon text-success-600 w-auto" />
                      Amenity
                    </Link>
                  </li>
                  <li className="">
                    <Link
                      to="/admin/bedtype"
                      className={
                        location.pathname === "/admin/bedtype"
                          ? "active-page"
                          : ""
                      }
                    >
                      <i className="ri-circle-fill circle-icon text-info-600 w-auto" />
                      Bed Type
                    </Link>
                  </li>
                  <li className="">
                    <Link
                      to="/admin/propertytype"
                      className={
                        location.pathname === "/admin/propertytype"
                          ? "active-page"
                          : ""
                      }
                    >
                      <i className="ri-circle-fill circle-icon text-warning-600 w-auto" />
                      Property Types
                    </Link>
                  </li>
                  <li className="">
                    <Link
                      to="/admin/room-types"
                      className={
                        location.pathname === "/admin/room-types"
                          ? "active-page"
                          : ""
                      }
                    >
                      <i className="ri-circle-fill circle-icon text-success-600 w-auto" />
                      Room Type
                    </Link>
                  </li>
                </ul>
              </li>
            )}

            {role === "admin" && (
              <li className="dropdown">
                <Link to="#">
                  <MdOutlineDirectionsBoat className="menu-icon" />

                  <span>Ferry Booking</span>
                </Link>
                <ul className="sidebar-submenu">
                  <li className="">
                    <Link
                      to="/admin/ferry-services"
                      className={
                        location.pathname === "/admin/ferry-services"
                          ? "active-page"
                          : ""
                      }
                    >
                      <i className="ri-circle-fill circle-icon text-danger-600 w-auto" />
                      Ferry Services
                    </Link>
                  </li>
                </ul>
              </li>
            )}

            {role === "admin" && (
              <li className="dropdown">
                <Link to="#">
                  <RiCarLine className="menu-icon" />

                  <span>Car Rental</span>
                </Link>
                <ul className="sidebar-submenu">
                  <li className="">
                    <Link
                      to="/admin/car-types"
                      className={
                        location.pathname === "/admin/car-types"
                          ? "active-page"
                          : ""
                      }
                    >
                      <i className="ri-circle-fill circle-icon text-warning-600 w-auto" />
                      Car Types
                    </Link>
                  </li>
                  <li className="">
                    <Link
                      to="/admin/carrental"
                      className={
                        location.pathname === "/admin/carrental"
                          ? "active-page"
                          : ""
                      }
                    >
                      <i className="ri-circle-fill circle-icon text-success-600 w-auto" />
                      Car Rental Packages
                    </Link>
                  </li>
                  <li className="">
                    <Link
                      to="/admin/airport-charges"
                      className={
                        location.pathname === "/admin/airport-charges"
                          ? "active-page"
                          : ""
                      }
                    >
                      <i className="ri-circle-fill circle-icon text-info-600 w-auto" />
                      Airport Pickup Drop
                    </Link>
                  </li>
                  <li className="">
                    <Link
                      to="/admin/hourly-car-charges"
                      className={
                        location.pathname === "/admin/hourly-car-charges"
                          ? "active-page"
                          : ""
                      }
                    >
                      <i className="ri-circle-fill circle-icon text-lilac-600 w-auto" />
                      Hourly Car Rental
                    </Link>
                  </li>
                  {/* <li className="">
                    <Link
                      to="/admin/placewise-hotel"
                      className={
                        location.pathname === "/admin/placewise-hotel"
                          ? "active-page"
                          : ""
                      }
                    >
                      <i className="ri-circle-fill circle-icon text-alert-600 w-auto" />
                      Place Wise Hotel
                    </Link>
                  </li> */}

                  <li className="">
                    <Link
                      to="/admin/pickup-drop"
                      className={
                        location.pathname === "/admin/pickup-drop"
                          ? "active-page"
                          : ""
                      }
                    >
                      <i className="ri-circle-fill circle-icon text-neutral-600 w-auto" />
                      Pickup Drop
                    </Link>
                  </li>
                </ul>
              </li>
            )}

            {role === "executive" && (
              <li className="dropdown">
                <Link to="#">
                  <RiCarLine className="menu-icon" />

                  <span>Car Rental</span>
                </Link>
                <ul className="sidebar-submenu">
                  <li className="">
                    <Link
                      to="/admin/car-types"
                      className={
                        location.pathname === "/admin/car-types"
                          ? "active-page"
                          : ""
                      }
                    >
                      <i className="ri-circle-fill circle-icon text-warning-600 w-auto" />
                      Car Types
                    </Link>
                  </li>
                  <li className="">
                    <Link
                      to="/admin/carrental"
                      className={
                        location.pathname === "/admin/carrental"
                          ? "active-page"
                          : ""
                      }
                    >
                      <i className="ri-circle-fill circle-icon text-success-600 w-auto" />
                      Car Rental Packages
                    </Link>
                  </li>
                  <li className="">
                    <Link
                      to="/admin/airport-charges"
                      className={
                        location.pathname === "/admin/airport-charges"
                          ? "active-page"
                          : ""
                      }
                    >
                      <i className="ri-circle-fill circle-icon text-info-600 w-auto" />
                      Airport Pickup Drop
                    </Link>
                  </li>
                  <li className="">
                    <Link
                      to="/admin/hourly-car-charges"
                      className={
                        location.pathname === "/admin/hourly-car-charges"
                          ? "active-page"
                          : ""
                      }
                    >
                      <i className="ri-circle-fill circle-icon text-lilac-600 w-auto" />
                      Hourly Car Rental
                    </Link>
                  </li>
                  {/* <li className="">
                    <Link
                      to="/admin/placewise-hotel"
                      className={
                        location.pathname === "/admin/placewise-hotel"
                          ? "active-page"
                          : ""
                      }
                    >
                      <i className="ri-circle-fill circle-icon text-alert-600 w-auto" />
                      Place Wise Hotel
                    </Link>
                  </li> */}

                  <li className="">
                    <Link
                      to="/admin/pickup-drop"
                      className={
                        location.pathname === "/admin/pickup-drop"
                          ? "active-page"
                          : ""
                      }
                    >
                      <i className="ri-circle-fill circle-icon text-neutral-600 w-auto" />
                      Pickup Drop
                    </Link>
                  </li>
                </ul>
              </li>
            )}

            {role === "admin" && (
              <li className="dropdown">
                <Link to="#">
                  <FaWaterLadder className="menu-icon" />

                  <span>Water Sports</span>
                </Link>
                <ul className="sidebar-submenu">
                  <li className="">
                    <Link
                      to="/admin/watersports"
                      className={
                        location.pathname === "/admin/watersports"
                          ? "active-page"
                          : ""
                      }
                    >
                      <i className="ri-circle-fill circle-icon text-warning-600 w-auto" />
                      Water Sports List
                    </Link>
                  </li>

                  {/* <li className="">
                    <Link
                      to="/admin/placewise-hotel"
                      className={
                        location.pathname === "/admin/placewise-hotel"
                          ? "active-page"
                          : ""
                      }
                    >
                      <i className="ri-circle-fill circle-icon text-success-600 w-auto" />
                      North Bay Island
                    </Link>
                  </li> */}
                </ul>
              </li>
            )}

            {role === "executive" && (
              <li className="dropdown">
                <Link to="#">
                  <FaWaterLadder className="menu-icon" />

                  <span>Water Sports</span>
                </Link>
                <ul className="sidebar-submenu">
                  <li className="">
                    <Link
                      to="/admin/watersports"
                      className={
                        location.pathname === "/admin/watersports"
                          ? "active-page"
                          : ""
                      }
                    >
                      <i className="ri-circle-fill circle-icon text-warning-600 w-auto" />
                      Water Sports List
                    </Link>
                  </li>

                  {/* <li className="">
                    <Link
                      to="/admin/placewise-hotel"
                      className={
                        location.pathname === "/admin/placewise-hotel"
                          ? "active-page"
                          : ""
                      }
                    >
                      <i className="ri-circle-fill circle-icon text-success-600 w-auto" />
                      North Bay Island
                    </Link>
                  </li> */}
                </ul>
              </li>
            )}

            {role === "admin" && (
              <li>
                <Link
                  to="/admin/enquiry"
                  className={
                    location.pathname === "/admin/enquiry" ? "active-page" : ""
                  }
                >
                  <RiQuestionAnswerLine className="menu-icon" />

                  <span>Enquiry</span>
                </Link>
              </li>
            )}
            {role === "executive" && (
              <li>
                <Link
                  to="/admin/enquiry"
                  className={
                    location.pathname === "/admin/enquiry" ? "active-page" : ""
                  }
                >
                  <RiQuestionAnswerLine className="menu-icon" />

                  <span>Enquiry</span>
                </Link>
              </li>
            )}

            {role === "hotelAdmin" && (
              <li className="">
                <Link
                  to="/admin/property"
                  className={
                    location.pathname === "/admin/property" ? "active-page" : ""
                  }
                >
                  <LuHotel className="menu-icon" />
                  <span>My Property</span>
                </Link>
              </li>
            )}

            <li className="">
              <Link onClick={logout}>
                <BiPowerOff className="menu-icon" />
                <span>Signout</span>
              </Link>
            </li>
          </ul>
        </div>
      </aside>

      <main
        className={sidebarActive ? "dashboard-main active" : "dashboard-main"}
      >
        <div className="navbar-header">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center gap-4">
                <button
                  type="button"
                  className="sidebar-toggle"
                  onClick={sidebarControl}
                >
                  {sidebarActive ? (
                    <Icon
                      icon="iconoir:arrow-right"
                      className="icon text-2xl non-active"
                    />
                  ) : (
                    <Icon
                      icon="heroicons:bars-3-solid"
                      className="icon text-2xl non-active "
                    />
                  )}
                </button>
                <button
                  onClick={mobileMenuControl}
                  type="button"
                  className="sidebar-mobile-toggle"
                >
                  <Icon icon="heroicons:bars-3-solid" className="icon" />
                </button>
              </div>
            </div>
            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center gap-3">
                {/* ThemeToggleButton */}
                <ThemeToggleButton />

                {/* Notification dropdown end */}
                <div className="dropdown">
                  <button
                    className="d-flex justify-content-center align-items-center rounded-circle"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    <img
                      src={userimg}
                      alt="image_user"
                      className="w-32-px h-32-px object-fit-cover rounded-circle"
                    />
                  </button>
                  <div className="dropdown-menu to-top dropdown-menu-sm">
                    <div className="py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                      <div>
                        <h6 className="text-lg text-primary-light fw-semibold mb-2">
                          Shaidul Islam
                        </h6>
                        <span className="text-secondary-light fw-medium text-sm">
                          Admin
                        </span>
                      </div>
                      <button type="button" className="hover-text-danger">
                        <Icon
                          icon="radix-icons:cross-1"
                          className="icon text-xl"
                        />
                      </button>
                    </div>
                    <ul className="to-top-list">
                      <li>
                        <Link
                          className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                          to="/view-profile"
                        >
                          <Icon
                            icon="solar:user-linear"
                            className="icon text-xl"
                          />{" "}
                          My Profile
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                          to="/email"
                        >
                          <Icon
                            icon="tabler:message-check"
                            className="icon text-xl"
                          />
                          Inbox
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                          to="/company"
                        >
                          <Icon
                            icon="icon-park-outline:setting-two"
                            className="icon text-xl"
                          />
                          Setting
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3"
                          onClick={logout}
                        >
                          <Icon icon="lucide:power" className="icon text-xl" />{" "}
                          Log Out
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* Profile dropdown end */}
              </div>
            </div>
          </div>
        </div>

        {/* dashboard-main-body */}
        <div className="dashboard-main-body">{children}</div>

        {/* Footer section */}
        <footer className="d-footer">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <p className="mb-0 text-md">
                © 2025 Andaman Make Holiday. All Rights Reserved.
              </p>
            </div>
            <div className="col-auto">
              <p className="mb-0 text-md">
                Developed by
                <span className="text-primary-600">Octal Optimum</span>
              </p>
            </div>
          </div>
        </footer>
      </main>
    </section>
  );
};

export default Layout;
